import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity } from "lucide-react";

/** Live platform-health pill for the topbar.
 *  Polls `/api/health/deep` every 60s and shows green / amber / red so ops can
 *  spot outages without opening Settings. Cheap tooltip lists per-check status. */
export default function HealthPill() {
  const [state, setState] = useState({ status: "loading", checks: {} });

  const ping = async () => {
    try {
      const r = await api.get("/health/deep");
      setState(r.data);
    } catch (e) {
      setState({ status: "red", checks: {}, error: e?.message || "unreachable" });
    }
  };

  useEffect(() => {
    ping();
    const t = setInterval(ping, 60000);
    return () => clearInterval(t);
  }, []);

  const color = state.status === "green"
    ? "bg-emerald-500 shadow-emerald-500/40"
    : state.status === "amber"
      ? "bg-amber-500 shadow-amber-500/40"
      : state.status === "red"
        ? "bg-red-500 shadow-red-500/40"
        : "bg-slate-400";

  const label = state.status === "green"
    ? "All systems"
    : state.status === "amber"
      ? "Degraded"
      : state.status === "red"
        ? "Down"
        : "…";

  const tooltip = Object.entries(state.checks || {})
    .map(([k, v]) => `${k}: ${v.ok ? "✓" : "✗"}${v.reason ? " · " + v.reason : ""}`)
    .join("\n") || "checking…";

  return (
    <div
      title={tooltip}
      data-testid="health-pill"
      className="hidden md:flex items-center gap-1.5 h-9 px-2.5 rounded-sm border cursor-help select-none"
    >
      <span className={`w-2 h-2 rounded-full shadow-sm ${color} animate-pulse`} />
      <Activity className="w-3.5 h-3.5 text-muted-foreground" />
      <span className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">{label}</span>
    </div>
  );
}
